exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.zip-download-banner{background-color:#184e78;color:#fff;display:flex;height:50px;text-align:center;white-space:nowrap;transition-property:all;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1);max-height:50px}.zip-download-banner__text{display:flex;font-family:Open Sans,sans-serif;line-height:26px;font-size:18px;font-weight:600;margin-left:auto;margin-top:12px;margin-bottom:12px}.zip-download-banner__link{cursor:pointer;font-weight:700;margin-top:0;text-decoration:underline}.zip-download-banner__company-name{margin-top:0;height:26px;max-width:740px;text-overflow:ellipsis;overflow:hidden}.zip-download-banner svg{margin-left:5px}.zip-download-banner__close{cursor:pointer;font-size:32px;margin-left:auto;margin-right:12px;margin-top:5px}.zip-download-banner--closing{max-height:0}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/banners/ZipDownloadNotificationBanner/ZipDownloadNotificationBanner.scss
// module id = 1694
// module chunks = 0